/* eslint-disable no-shadow */
import moment from 'moment';

export const state = {
    blacklist: null,
};

export const mutations = {
    set(state, {property, payload}) {
        state[property] = payload;
    },
};

export const actions = ({api}) => ({
    async add({commit}, blacklistItem) {
        const expirationTime = blacklistItem.expirationTime
            ? moment().utc().add(blacklistItem.expirationTime, 'seconds').format()
            : null;
        const payload = {
            ...blacklistItem.getPayload(),
            expirationTime,
        };
        const params = {
            data: payload,
        };
        await api(({blacklists}) => blacklists.create(params));
        commit('set', {
            property: 'blacklist',
            payload,
        });
    },
});
